module.exports = __webpack_public_path__ + "img/checked-inverse.ab39f935.svg";